import script from "./Skelaton.vue?vue&type=script&setup=true&lang=js"
export * from "./Skelaton.vue?vue&type=script&setup=true&lang=js"

import "./Skelaton.vue?vue&type=style&index=0&id=4f984068&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f984068"]])

export default __exports__